import { render, staticRenderFns } from "./alert-types.vue?vue&type=template&id=2210f6fa&"
import script from "./alert-types.vue?vue&type=script&lang=js&"
export * from "./alert-types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports